module.exports = __webpack_public_path__ + "static/img/meishulv.5b32c5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/meishulv.jpg
// module id = Zo57
// module chunks = 0